// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2FMBZ","gfeWrapper":"CalendarEvent_gfeWrapper__2uWmS"};